module.exports = __webpack_public_path__ + "img/job-Inprogress.c3ff8746.svg";